<script lang="ts" setup>
import { SystemGetAuthSystemListByLoginPOST } from '@/api/user-system/System'
import { UserBaseInfoGetCurrentUserBasicInfoPOST } from '@/api/user-user/UserBaseInfo'

defineProps({
  layout: {
    type: String,
    default: '',
  },
  showTabs: {
    type: Boolean,
    default() {
      return true
    },
  },
})

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()
const tabsStore = useTabsStore()
const {
  setSysBusinessType,
  setBusinessSubSystemId,
  setSysBusinessKey,
  setCompanyId,
  setCompanyCode,
  setDepartmentId,
  setSystemData,
  setBusinessRoleEnums,
  setCurrency,
  setUserEnName,
  setDepartmentEnName,
} = userStore
const { businessSubSystemId, userId } = toRefs(userStore)

const typeList = ref<any[]>([])
async function ckFn(n: any) {
  setSysBusinessType(n.sysBusinessType)
  // nameStr.value = n.cnName
  setSysBusinessKey(n.key!)
  setBusinessSubSystemId(n.id!)
  tabsStore.delAllVisitedRoutes()
  await router.push('/')
  location.reload()
}
onMounted(async () => {
  const data = await SystemGetAuthSystemListByLoginPOST({
    isBusinessType: true,
  })
  if (data.code === '200') {
    typeList.value = data.data

    setSystemData(data.data)
    if (!businessSubSystemId.value || route.query.businessSubSystemId) {
      const id = Number(route.query.businessSubSystemId || 0)
      let item = data.data[0]
      if (id) {
        item = data.data.filter(item => item.id === id)?.[0]
      }
      setSysBusinessType(item.sysBusinessType!)
      setBusinessSubSystemId(item.id!)
      setSysBusinessKey(item.key!)
    }
  }
  await UserBaseInfoGetCurrentUserBasicInfoPOST({
    userId: userId.value as number,
  }).then((res) => {
    if (res.code === '200') {
      setCompanyId((res.data as UserApi.CurrentUserInfo).companyId!)
      setBusinessRoleEnums((res.data as UserApi.CurrentUserInfo).businessRoleEnums!)
      setDepartmentId((res.data as UserApi.CurrentUserInfo).departmentId!)
      setCompanyCode((res.data as UserApi.CurrentUserInfo).companyCode!)
      setCurrency((res.data as UserApi.CurrentUserInfo).currencyCode!)
      setUserEnName((res.data as UserApi.CurrentUserInfo).userEnName!)
      setDepartmentEnName((res.data as UserApi.CurrentUserInfo).departmentEnName!)
    }
  })
})
</script>

<template>
  <div class="sjzy-nav flex-b bg-[var(--sjzy-bg)]">
    <div class="left-panel">
      <LayoutTabsLabel v-show="showTabs" />
    </div>
    <div class="right-panel p-l-10px">
      <LayoutTabsLabelMore v-show="showTabs" />
      <LayoutRefresh class="h-full" />
      <LayoutFullScreen class="h-full" />
      <VabNotice />
      <!-- <LayoutDark /> -->
      <LayoutLanguage class="h-full hover:bg-[#f6f6f6] dark:text-[#fff] dark:hover:bg-[#333]" />
      <ElPopover v-if="typeList.length > 1" placement="top-start" :width="200" trigger="hover">
        <template #reference>
          <div class="ml-20px">
            {{ typeList.find((i) => i.id === businessSubSystemId)?.cnName }}
            <SjzyIcon
              icon-font="icon-changyong_qiehuan"
              class="mr-5px"
              style="vertical-align: middle"
            />
          </div>
        </template>
        <div class="w-170px">
          <div
            v-for="n in typeList"
            :key="n.id"
            class="cursor-name cursor-pointer p-l-16px p-r-16px lh-36px"
            :class="{
              'text-[var(--sjzy-color-primary)]': businessSubSystemId === n.id,
              'bg-#F7F7F7': businessSubSystemId === n.id,
            }"
            @click="ckFn(n)"
          >
            <div class="cursor-name-text">
              {{ n.cnName }}
            </div>
            <SjzyIcon
              v-if="businessSubSystemId === n.id"
              icon-font="icon-a-xuanzhong42"
              class="ml-5px mr-0"
            />
          </div>
        </div>
      </ElPopover>
      <!-- <LayoutTheme class="h-full" /> -->
      <LayoutAvatar class="h-full hover:bg-[#f6f6f6] dark:text-[#fff] dark:hover:bg-[#333]" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sjzy-nav {
  position: relative;
  height: var(--sjzy-nav-height);
  padding-right: var(--sjzy-base-padding);
  padding-left: var(--sjzy-base-padding);
  overflow: hidden;
  user-select: none;
  box-shadow: var(--sjzy-box-shadow);

  .left-panel {
    display: flex;
    flex: 1;
    place-items: center center;
    min-width: 840px;
    height: var(--sjzy-nav-height);
    overflow: hidden;

    :deep() {
      .fold-unfold {
        margin-right: 6px;
      }
    }
  }

  .right-panel {
    display: flex;
    place-content: center flex-end;
    align-items: center;
    width: max-content;
    height: var(--sjzy-nav-height);

    :deep() {
      .icon-btn {
        padding: 0 10px;
        color: var(--el-color-grey);
        cursor: pointer;
      }

      button {
        [class*='ri-'] {
          margin-left: 0;
          color: var(--el-color-white);
          cursor: pointer;
        }
      }
    }
  }
}

.cursor-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  > .cursor-name-text {
    width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
